// Copyright (c) 2017 Deere & Company

import MachineStatusUpdatesAccordionContainer from './machine-status-updates-accordion';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    machineStatusItemToUpdate: state.tcsm.wip.machineStatusItemToUpdate,
    machineStatusModal: state.tcsm.wip.machineStatusModal,
    machineStatusSearchFilters: state.tcsm.wip.machineStatusSearchFilters,
    machineStatusUpdates: state.tcsm.wip.machineStatusUpdates
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    const {
        approveDenyMachineStatus,
        closeMachineStatusModal,
        exportMachineStatusUpdates,
        machineStatusItemToUpdate,
        openMachineStatusModal,
        updateCommentsToDealer,
        updateInternalDeereComments,
        updateMachineStatusListFilterBy,
        updateMachineStatusListSortBy,
        updateMachineStatusListSortDirection
    } = dispatchProps;

    return {
        ...stateProps,
        actions: {
            approveDenyMachineStatus,
            closeMachineStatusModal,
            exportMachineStatusUpdates,
            machineStatusItemToUpdate,
            openMachineStatusModal,
            updateCommentsToDealer,
            updateInternalDeereComments,
            updateMachineStatusListFilterBy,
            updateMachineStatusListSortBy,
            updateMachineStatusListSortDirection
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(MachineStatusUpdatesAccordionContainer);



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/machine-status-updates/index.js